import React from "react";
// import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import Loader from "../components/Loader";
import CustomHeading from "../components/CustomHeading";
import HeroCarousel from "../components/HeroCarousel";
import MoviesListCarousel from '../components/MoviesListCarousel'

import { Helmet } from "react-helmet";

import {
  getTrendingMovies,
  getPopularMovies,
  getInTheatresMovies,
  getTopRatedMovies,
  getAnime,
  getUpcomingMovies,
  getPopularTvSeries
} from "../services/api";
import UseFetch from "../hooks/UseFetch";

function Home() {
  const { data: trendingData, loading: trendingLoading, error: trendingError } = UseFetch(getTrendingMovies);
  const { data: popularData, loading: popularLoading, error: popularError } = UseFetch(getPopularMovies);
  const { data: animeData, loading: animeLoading, error: animeError } = UseFetch(getAnime);
  const { data: theatresData, loading: theatresLoading, error: theatresError } = UseFetch(getInTheatresMovies);
  const { data: topRatedData, loading: topRatedLoading, error: topRatedError } = UseFetch(getTopRatedMovies);
  const { data: upcomingData, loading: upcomingLoading, error: upcomingError } = UseFetch(getUpcomingMovies);
  const { data: tvSeriesData, loading: tvSeriesLoading, error: tvSeriesError } = UseFetch(getPopularTvSeries);


  return (
    <>
      <Helmet>
        <title>Home - MovieFlix</title>
        <meta name="description" content="Discover the latest movies, TV series, and anime on MovieFlix. Explore trending, popular, and top-rated content." />
        <meta name="keywords" content="movies, tv series, anime, trending, popular, top-rated, in theatres, upcoming" />
      </Helmet>
      <main className="">
        <div>
          {(trendingLoading || theatresLoading || topRatedLoading || animeLoading || popularLoading || upcomingLoading || tvSeriesLoading) ? (
            <Loader />
          ) : (trendingError || theatresError || topRatedError || animeError || popularError || upcomingError || tvSeriesError) ? (
            <div className="flex justify-center items-center h-screen">
              <div className="alert alert-danger text-center" role="alert">
                <h2 className="alert-heading">Error fetching movies</h2>
              </div>
            </div>
          ) : (
            <div>
              {/* header starts */}
              <div className="bg-dark">
                <div className="mb-6">
                  <Navbar />

                  <div>
                    {/* carousel */}
                    <HeroCarousel movies={trendingData.results} />
                  </div>

                </div>
              </div>
              {/* header ends */}


              <div className="md:px-7 px-4">

                {/* Popular Movies Carousel */}
                <section className="mt-6 mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="Popular Movies" />

                    <Link to="/movies" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="movie" movies={popularData?.results || []} />
                </section>

                {/* Upcoming Movies Carousel */}
                <section className="mt-6 mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="Upcoming Movies" />

                    <Link to="/upcoming" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="movie" movies={upcomingData?.results || []} />
                </section>

                {/* TV Series Carousel */}
                <section className="mt-6 mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="Popular TV Series" />

                    <Link to="/tv-series" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="tv" movies={tvSeriesData?.results || []} />
                </section>

                {/* Anime Carousel */}
                <section className="mt-6 mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="Anime Series" />

                    <Link to="/anime" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="tv" movies={animeData?.results || []} />
                </section>

                {/* In Theatres Carousel */}
                <section className="mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="In Theatres" />

                    <Link to="/theatres" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="movie" movies={theatresData?.results || []} />
                </section>

                {/* Top Rated Carousel */}
                <section className="mb-10">
                  <div className="flex justify-between items-center flex-wrap gap-4 ">
                    <CustomHeading title="Top Rated Movies" />

                    <Link to="/top-rated" className="py-1.5 px-3 bg-pink-500 hover:bg-transparent border-2 border-pink-500 text-sm sm:text-base text-gray-100 hover:text-pink-500 duration-200 rounded">
                      View All
                    </Link>
                  </div>

                  <MoviesListCarousel type="movie" movies={topRatedData?.results || []} />
                </section>

                {/* Footer */}
                <Footer />

              </div>
            </div>
          )}
        </div>
      </main>
    </>
  );
}

export default Home;
